import component from '@123/druid/dist/Framework/Decorators/Component';
import {inject, injectable} from '@123/druid/dist/Framework/Decorators/Inject';
import type {AidenEvent} from '@Service/Aiden/Type/AidenEvent';
import ShoppingCart from '@Component/ShoppingCart/ShoppingCart';

@injectable()
@component
export default class AidenListener {
    constructor(@inject(ShoppingCart) private readonly shoppingCart: ShoppingCart) {}

    public listen(): void {
        window.addEventListener('aiden-actions', ((e: AidenEvent) => this.onAidenAction(e)) as EventListener);
    }

    private onAidenAction(event: AidenEvent): void {
        if (event.detail.actionId !== 'aiden-add-to-cart') {
            event.detail.abortCallback();
            return;
        }
        event.detail.acknowledgeCallback();
        this.onAidenAddToCart(event);
    }

    private onAidenAddToCart(event: AidenEvent): void {
        if (event.detail.products[0]) {
            this.shoppingCart
                .addProduct({productCode: event.detail.products[0].id, amount: event.detail.products[0].quantity || 1})
                .then(() => event.detail.successCallback())
                .catch(() => event.detail.failedCallback());
            event.stopImmediatePropagation();
        }
    }
}
